import { ApiEndpoints } from "../../utils/app-constants";
import { toShortDate } from "../../utils/date-utils";
import { DOCUMENT_EXTENSIONS, DOCUMENT_REQUEST_LOCATION, IDocumentRequest } from "../utilities/document-request";
import { API_METHODS } from "../utilities/type-models";

export class FullviewExportDocument implements IDocumentRequest {

    public filename: string = '';
    public fileExtension: DOCUMENT_EXTENSIONS = 'csv';
    public openInTab: boolean = false;
    public url: string = '';
    public reportLocation: DOCUMENT_REQUEST_LOCATION = 'api';
    public methodType: API_METHODS = 'GET';

    constructor(cutoffDate: Date) {

        var cutoffDateStr = toShortDate(cutoffDate);

        const searchParams = new URLSearchParams();
        searchParams.append('cutoffDate', cutoffDateStr);

        var args = searchParams.toString();
        this.url = `${ApiEndpoints.FULLVIEW_EXPORT}?${args}`;
        this.filename = `Fullview_Export_${cutoffDate}`;
    }
}
